import apiClient from './apiClient';

export const getQuestions = (passage_id) => {
    console.log(passage_id);
    return apiClient.get(`/questions/?api_key=1234&passage_id=${passage_id}`);
};